import '../styles/globals.css'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import * as gtag from '../lib/gtag'
import Script from "next/script";
import Layout from '/src/components/Layout'
import Navbar from '/src/components/Navbar.js'


function MyApp({ Component, pageProps }) {
  const router = useRouter()

  useEffect(() => {
    const handleRouteChange = (url) => {
      gtag.pageview(url)
    }
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  return (
    <>
    
    {/* <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8631388926560357" crossorigin="anonymous"></script>  */}
    <ins zone-max-id='8655' class='maxAdServer'></ins>
    <script data-cfasync='false' defer type='text/javascript' src='https://ad.maxadserver.media/script.js' ></script>

    <Layout>
      <Navbar />
      <Component {...pageProps} />
    </Layout>
    </>
  )
}

export default MyApp
